module.exports = __webpack_public_path__ + "assets/a8bdcd06fe84b68fb48eec7796713cf4.jpg";